import styled from 'styled-components';

export const ScrollContainer = styled.div`
  overflow: hidden;
  overflow-y: overlay;
  height: 100%;
  background: #fff;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 100%;

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: transparent;
  } 
  ::-webkit-scrollbar {
    width: 8px !important;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  ::-webkit-scrollbar-track:hover {
    -webkit-box-shadow: transparent !important;
    border-radius: 10px;
    background: rgba(222, 222, 222, 0.6);
  }
  ::-webkit-scrollbar-thumb:hover {
    border-radius: 10px;
    -webkit-box-shadow: transparent !important;
    background-color: #3bcabd;
  }
  &.on-scrollbar::-webkit-scrollbar-track {
    -webkit-box-shadow: transparent !important;
    border-radius: 10px;
    background: rgba(222, 222, 222, 0.6);
  }

  &.on-scrollbar::-webkit-scrollbar {
    width: 8px;
  }

  &.on-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: transparent !important;
    background-color: #3bcabd;
  }

  .slide-in {
    width: 40%;
    opacity: 1;
  }

  .anticon.anticon-arrow-up {
    position: absolute;
    bottom: 80px;
    right: 0;
    background: rgb(37, 41, 45);
    color: #fff;
    padding: 15px;
    font-size: 20px;
    @media only screen and (min-width: 1460px) {
      font-size: 25px;
    }
    z-index: 300;
  }
`;